<template>
  <transition name="fade" mode="out-in">
    <keep-alive include="resolved-history">
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>
<script>
  export default {}
</script>